module.exports = __webpack_public_path__ + "f211d3507647d53ee33c66c3dcbca822.svg";